// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nSlxF","input":"styles_input__19VM1"};